// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.flex-centered-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dt-page-title {
  color: #0669B3;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 16px 0px;
}

.manage-template-container {
  border-radius: 10px;
  background-color: #EDEDED;
  margin-top: 16px;
  padding: 16px;
}

.manage-template-title {
  color: #0669B3;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 0px;
  margin-top: 20px;
}

.create-dt-btn-wrapper {
  margin: 16px -12px;
}

.dt-button-wrapper {
  min-width: 558px;
}

.warning-modal-title-color {
  color: #CB321A;
}

.district-template-status {
  border-radius: 20px;
  background: white;
  color: #0A4064;
  font-size: 16px;
  font-weight: 700;
  margin: 16px 0px;
  padding: 4px 16px;
  width: fit-content;
}
.district-template-status span {
  color: black;
  font-size: 16px;
  font-style: italic;
  font-weight: 500;
}

.released-to-schools {
  background: #008000;
  color: white;
}
.released-to-schools span {
  color: white;
}

.not-yet-created {
  border: 2px solid #CB321A;
}

.under-review {
  border: 2px solid #FEBF31;
}

.reviewed {
  border: 2px solid green;
}

.manage-helper-text {
  margin-top: 40px;
}
.manage-helper-text .manage-district-callout {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  display: block;
}

.missing-content-warning-box {
  margin: 16px 0px;
  border: 1px solid #FED883;
  padding: 8px 16px;
  border-radius: 10px;
  background: #FEBF31;
  width: fit-content;
}

.modal-btn-group {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.review-content-section {
  border-radius: 5px;
  background-color: #EDEDED;
  margin-bottom: 8px;
  padding: 4px;
}

.dt-grade-btn-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 16px 0px 32px 0px;
  width: 100%;
}

.btn-container {
  position: relative;
}

.completed-status-on-grade-button {
  position: absolute;
  right: -10px;
  top: -10px;
}

.completed-content-by-grade {
  position: absolute;
  bottom: 13px;
  left: 88%;
}

.dt-review-grey-container {
  border-radius: 10px;
  background-color: #808080;
  margin-top: 32px;
  min-height: 550px;
  padding-top: 16px;
  width: 100%;
}

.dt-review-sub-section-title {
  color: #EDEDED;
  font-size: 24px;
  font-weight: 600;
  margin: 16px;
}

.content-area-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: 0px 16px;
  width: 33%;
}

.content-container {
  margin-right: 24px;
  margin-top: 8px;
  overflow: scroll;
  width: 100%;
}

.dt-std-accordion-item {
  border-radius: 5px;
  border: 1px solid #A7A9AC;
  margin-bottom: 12px;
  overflow: auto;
}

.subject-button {
  border-radius: 5px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  align-items: center;
  background-color: #EDf0F1;
  color: #636161;
  display: flex;
  font-weight: 600;
  font-size: 20px;
  justify-content: space-between;
  margin: 8px;
  padding: 4px 8px;
}

.subject-button-selected {
  border-radius: 5px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  align-items: center;
  background-color: #0669B3;
  color: #EDEDED;
  display: flex;
  font-weight: 600;
  font-size: 20px;
  justify-content: space-between;
  margin: 8px;
  padding: 4px 8px;
}

.select-grade-message {
  border-radius: 5px;
  background: #636161;
  color: #EDEDED;
  font-size: 1.1rem;
  font-weight: 500;
  margin-top: 32px;
  padding: 16px;
}

.no-content-warning {
  border-radius: 5px;
  background-color: white;
  border: 3px solid #FEBF31;
  color: #444343;
  margin-bottom: 24px;
  min-height: 55px;
  padding: 16px;
}
.no-content-warning .no-content-warning-title {
  align-items: center;
  display: flex;
  font-size: 20px;
  font-weight: 500;
}
.no-content-warning span {
  margin-left: 8px;
}

.complete-check-btn {
  border-radius: 5px;
  align-items: center;
  background-color: white;
  color: #0669B3;
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
  min-width: 160px;
  padding: 4px 8px;
}
.complete-check-btn input {
  margin-right: 12px;
  transform: scale(1.2);
}
.complete-check-btn span {
  font-size: 20px;
}

.complete-check-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 32px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/DistrictTemplate.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAUJ;;AAPA;EACI,cDsBS;ECrBT,eAAA;EACA,gBAAA;EACA,uBAAA;AAUJ;;AAPA;ECbI,mBDcsB;EACtB,yBDFI;ECGJ,gBAAA;EACA,aAAA;AAUJ;;AAPA;EACI,cDQS;ECPT,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAUJ;;AAPA;EACI,kBAAA;AAUJ;;AAPA;EACI,gBAAA;AAUJ;;AAPA;EACI,cDtBE;ACgCN;;AAPA;ECxCI,mBDyCsB;EACtB,iBAAA;EACA,cDrCM;ECsCN,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAUJ;AATI;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAWR;;AAPA;EACI,mBAAA;EACA,YAAA;AAUJ;AATI;EACI,YAAA;AAWR;;AAPA;EACI,yBAAA;AAUJ;;AAPA;EACI,yBAAA;AAUJ;;AAPA;EACI,uBAAA;AAUJ;;AAPA;EACI,gBAAA;AAUJ;AARI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAUR;;AANA;EACI,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBDzEQ;EC0ER,kBAAA;AASJ;;AANA;EACI,aAAA;EACA,yBAAA;EACA,gBAAA;AASJ;;AANA;ECvGI,kBDwGsB;EACtB,yBD5FI;EC6FJ,kBAAA;EACA,YAAA;AASJ;;AALA;EACI,aAAA;EACA,eAAA;EACA,6BAAA;EACA,yBAAA;EACA,WAAA;AAQJ;;AALA;EACI,kBAAA;AAQJ;;AALA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;AAQJ;;AALA;EACI,kBAAA;EACA,YAAA;EACA,SAAA;AAQJ;;AALA;ECvII,mBDwIsB;EACtB,yBDhHI;ECiHJ,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;AAQJ;;AALA;EACI,cDpII;ECqIJ,eAAA;EACA,gBAAA;EACA,YAAA;AAQJ;;AALA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,UAAA;AAQJ;;AALA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAQJ;;AALA;ECvKI,kBDwKsB;EACtB,yBAAA;EACA,mBAAA;EACA,cAAA;AAQJ;;AALA;EC9KI,kBD+KsB;EC1JtB,2CAAA;ED4JA,eAAA;EACA,mBAAA;EACA,yBD7JI;EC8JJ,cDzJI;EC0JJ,aAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;AAQJ;;AALA;EC7LI,kBD8LsB;ECzKtB,2CAAA;ED2KA,eAAA;EACA,mBAAA;EACA,yBDrKS;ECsKT,cDtLI;ECuLJ,aAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;AAQJ;;AALA;EC5MI,kBD6MsB;EACtB,mBDnLI;ECoLJ,cDlMI;ECmMJ,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AAQJ;;AALA;ECtNI,kBDuNsB;EACtB,uBAAA;EACA,yBAAA;EACA,cD9LK;EC+LL,mBAAA;EACA,gBAAA;EACA,aAAA;AAQJ;AANI;EACI,mBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AAQR;AALI;EACI,gBAAA;AAOR;;AAHA;EC3OI,kBD4OsB;EACtB,mBAAA;EACA,uBAAA;EACA,cDlNS;ECmNT,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAMJ;AALI;EACI,kBAAA;EACA,qBAAA;AAOR;AALI;EACI,eAAA;AAOR;;AAHA;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;AAMJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.flex-centered-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.dt-page-title {\n    color: $pearl-blue;\n    font-size: 24px;\n    font-weight: 700;\n    margin-bottom: 16px 0px;\n}\n\n.manage-template-container {\n    @include borderRadius(10px);\n    background-color: $white;\n    margin-top: 16px;\n    padding: 16px;\n}\n\n.manage-template-title {\n    color: $pearl-blue;\n    font-size: 20px;\n    font-weight: 700;\n    margin-bottom: 0px;\n    margin-top: 20px;\n}\n\n.create-dt-btn-wrapper {\n    margin: 16px -12px;\n}\n\n.dt-button-wrapper {\n    min-width: 558px;\n}\n\n.warning-modal-title-color {\n    color: $red;\n}\n\n.district-template-status {\n    @include borderRadius(20px);\n    background: white;\n    color: $dk-blue;\n    font-size: 16px;\n    font-weight: 700;\n    margin: 16px 0px;\n    padding: 4px 16px;\n    width: fit-content;\n    span {\n        color: black;\n        font-size: 16px;\n        font-style: italic;\n        font-weight: 500;\n    }\n}\n\n.released-to-schools {\n    background: #008000;\n    color: white;\n    span {\n        color: white;\n    }\n}\n\n.not-yet-created {\n    border: 2px solid $red;\n}\n\n.under-review {\n    border: 2px solid $important;\n}\n\n.reviewed {\n    border: 2px solid green;\n}\n\n.manage-helper-text {\n    margin-top: 40px;\n\n    .manage-district-callout {\n        font-size: 16px;\n        font-weight: 600;\n        margin-bottom: 16px;\n        display: block;\n    }\n}\n\n.missing-content-warning-box {\n    margin: 16px 0px;\n    border: 1px solid $lt-important;\n    padding: 8px 16px;\n    border-radius: 10px;\n    background: $important;\n    width: fit-content;\n}\n\n.modal-btn-group {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 16px;\n}\n\n.review-content-section {\n    @include borderRadius(5px);\n    background-color: $white;\n    margin-bottom: 8px;\n    padding: 4px;\n\n}\n\n.dt-grade-btn-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    margin: 16px 0px 32px 0px;\n    width: 100%;\n}\n\n.btn-container {\n    position: relative;\n}\n\n.completed-status-on-grade-button {\n    position: absolute;\n    right: -10px;\n    top: -10px;\n}\n\n.completed-content-by-grade {\n    position: absolute;\n    bottom: 13px;\n    left: 88%;\n}\n\n.dt-review-grey-container {\n    @include borderRadius(10px);\n    background-color: $grey3;\n    margin-top: 32px;\n    min-height: 550px;\n    padding-top: 16px;\n    width: 100%;\n}\n\n.dt-review-sub-section-title {\n    color: $white;\n    font-size: 24px;\n    font-weight: 600;\n    margin: 16px;\n}\n\n.content-area-container {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    justify-content: space-between;\n    padding: 0px 16px;\n    width: 33%;\n}\n\n.content-container {\n    margin-right: 24px;\n    margin-top: 8px;\n    overflow: scroll;\n    width: 100%;\n}\n\n.dt-std-accordion-item {\n    @include borderRadius(5px);\n    border: 1px solid $grey2;\n    margin-bottom: 12px;\n    overflow: auto;\n}\n\n.subject-button {\n    @include borderRadius(5px);\n    @include shadow();\n    cursor: pointer;\n    align-items: center;\n    background-color: $grey0;\n    color: $grey4;\n    display: flex;\n    font-weight: 600;\n    font-size: 20px;\n    justify-content: space-between;\n    margin: 8px;\n    padding: 4px 8px;\n}\n\n.subject-button-selected {\n    @include borderRadius(5px);\n    @include shadow();\n    cursor: pointer;\n    align-items: center;\n    background-color: $pearl-blue;\n    color: $white;\n    display: flex;\n    font-weight: 600;\n    font-size: 20px;\n    justify-content: space-between;\n    margin: 8px;\n    padding: 4px 8px;\n}\n\n.select-grade-message {\n    @include borderRadius(5px);\n    background: $grey4;\n    color: $white;\n    font-size: 1.1rem;\n    font-weight: 500;\n    margin-top: 32px;\n    padding: 16px;\n}\n\n.no-content-warning {\n    @include borderRadius(5px);\n    background-color: white;\n    border: 3px solid $important;\n    color: $grey4a;\n    margin-bottom: 24px;\n    min-height: 55px;\n    padding: 16px;\n\n    .no-content-warning-title {\n        align-items: center;\n        display: flex;\n        font-size: 20px;\n        font-weight: 500;\n    }\n\n    span {\n        margin-left: 8px;\n    }\n}\n\n.complete-check-btn {\n    @include borderRadius(5px);\n    align-items: center;\n    background-color: white;\n    color: $pearl-blue;\n    display: flex;\n    justify-content: center;\n    margin-bottom: 32px;\n    min-width: 160px;\n    padding: 4px 8px;\n    input {\n        margin-right: 12px;\n        transform: scale(1.2)\n    }\n    span {\n        font-size: 20px;\n    }\n}\n\n.complete-check-wrapper {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 32px;\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
